import { BoundingBox, insideBoundingBox } from "geolocation-utils";
import { query, where, getDocs, collection } from "firebase/firestore";

import { Utils } from "utils";
import { db } from "configs/firebase";
import { COLLECTIONS } from "constants/firebase";
import { ICurveRoad, IFirestoreCurveRoad, Iterable } from "types";

export const forCountries = async (
  codes: string[],
  restrictions?: { minDistance?: number; insideRouteBBox?: BoundingBox }
) => {
  try {
    const { minDistance, insideRouteBBox } = restrictions ?? {};
    const coll = collection(db, COLLECTIONS.CURVE_ROADS);

    // Fetch All roads related to country;
    const responses = await Promise.all(
      codes.map((code) =>
        getDocs(query(coll, where("countryCode", "==", code)))
      )
    );

    // Parse Roads (Convert string coordinates to number[][]);
    let documents = responses.map((response) => {
      const docs =
        Utils.Helpers.castDocs<Iterable<IFirestoreCurveRoad>>(response);
      return docs.map(
        (doc) =>
          ({
            ...doc,
            geometry: {
              type: doc.type,
              coordinates: JSON.parse(doc.geometry.coordinates),
            },
          } as Iterable<ICurveRoad>)
      );
    });

    // Filter roads if minDistance exists;
    if (minDistance) {
      documents = [
        ...documents.map((doc) =>
          doc.filter((item) => item.distance >= minDistance)
        ),
      ];
    }

    // Filter roads if current route bbox exists;
    if (insideRouteBBox) {
      documents = documents.map((doc) => {
        return doc.filter((item) => {
          const { coordinates } = item.geometry;

          const first = coordinates[0];
          const last = coordinates[coordinates.length - 1];

          const isStartInside = insideBoundingBox(
            { lat: first[1], lng: first[0] },
            insideRouteBBox
          );

          const isLastInside = insideBoundingBox(
            { lat: last[1], lng: last[0] },
            insideRouteBBox
          );

          return isStartInside && isLastInside;
        });
      });
    }

    return Promise.resolve(documents);
  } catch (error) {
    return Promise.reject(error);
  }
};
